import { createAction, handleActions } from 'redux-actions';
import { takeLatest, call } from 'redux-saga/effects';
import * as stAPI from '../../lib/api/stapi';
import * as userAPI from '../../lib/api/userapi';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';

/**
 * 사용자 상태 저장 리덕스 모듈 
 */

/**
 * 액션 타입 정의 
 */
// 공간 클립
const [
    REQ_TYPE_USER_SPACE_ADD,
    REQ_TYPE_USER_SPACE_ADD_SUCCESS,
    REQ_TYPE_USER_SPACE_ADD_FAILURE,
] = createRequestActionTypes('userSpace/SPACE_ADD');

const [
    REQ_TYPE_USER_SPACE_DEL,
    REQ_TYPE_USER_SPACE_DEL_SUCCESS,
    REQ_TYPE_USER_SPACE_DEL_FAILURE,
] = createRequestActionTypes('userSpace/SPACE_DEL');

const [
    REQ_TYPE_USER_SPACE_DEL_ALL,
    REQ_TYPE_USER_SPACE_DEL_ALL_SUCCESS,
    REQ_TYPE_USER_SPACE_DEL_ALL_FAILURE,
] = createRequestActionTypes('userSpace/SPACE_DEL_ALL');


// 클립 상품 저장
const SET_CLIP_SPACE_ID = 'userSpace/SET_CLIP_SPACE_ID';
// 좋아요 상품
const [SPACE, SPACE_SUCCESS, SPACE_FAILURE] = createRequestActionTypes(
    'userSpace/SPACE',
);

//상품 클립 추가
export const setUserSpaceAddAction = createAction(REQ_TYPE_USER_SPACE_ADD, (email, spaceid) => {
    return { email, spaceid }
});

//상품 클립 삭제
export const setUserSpaceDelAction = createAction(REQ_TYPE_USER_SPACE_DEL, (email, spaceid) => {
    return { email, spaceid }
});

export const setUserSpaceDelAllAction = createAction(REQ_TYPE_USER_SPACE_DEL_ALL, (email) => {
    return { email }
});

export const setClipSpaceIdAction = createAction(SET_CLIP_SPACE_ID);

export const spaceAction = createAction(SPACE, (email) => {
    return { email }
});


/**
 * Networ 통신 : Saga Lib 사용 
 */
const spaceSaga = createRequestSaga(SPACE, userAPI.space);
//상품 클립 추가
const spaceAddSaga = createRequestSaga(REQ_TYPE_USER_SPACE_ADD, stAPI.spaceAdd);
const spaceDelSaga = createRequestSaga(REQ_TYPE_USER_SPACE_DEL, stAPI.spaceDel);
const spaceDelAllSaga = createRequestSaga(REQ_TYPE_USER_SPACE_DEL_ALL, stAPI.spaceDelAll);

export function* userSpaceSaga() {
    yield takeLatest(SPACE, spaceSaga);
    yield takeLatest(REQ_TYPE_USER_SPACE_ADD, spaceAddSaga);
    yield takeLatest(REQ_TYPE_USER_SPACE_DEL, spaceDelSaga);
    yield takeLatest(REQ_TYPE_USER_SPACE_DEL_ALL, spaceDelAllSaga);
}


/**
 * 리덕스 모듈 초기값 
 */
const initialState = {
    clipSpaceIds: null, //좋아요 상품
    spaceClipResult: null,       //상품 클립(좋아요) 결과
    error: null,

};

/**
 * 리덕스 액션 연결 
 */
const userSpaceReducer = handleActions(
    {
        [SET_CLIP_SPACE_ID]: (state, { payload: clipSpaceIds }) => ({
            ...state,
            clipSpaceIds: clipSpaceIds,
        }),
        [SPACE_SUCCESS]: (state, { payload: clipSpaceIds }) => {
            let data = [];
            if (clipSpaceIds !== null & clipSpaceIds.length > 0) {
                clipSpaceIds.forEach(element => {
                    data.push(element.st_id)

                });
            }
            return {
                ...state,
                clipSpaceIds: data,
            }

        },
        [SPACE_FAILURE]: (state, { payload: error }) => {
            return {
                ...state,
                error: error,
                clipSpaceIds: null,
            }
        },
        [REQ_TYPE_USER_SPACE_ADD_SUCCESS]: (state, { payload: spaceClipResult }) => {
            return ({

                ...state,
                error: null,
                spaceClipResult: spaceClipResult,
            })
        },
        [REQ_TYPE_USER_SPACE_ADD_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error: error,
                spaceClipResult:null,
            })
        },
        [REQ_TYPE_USER_SPACE_DEL_SUCCESS]: (state, { payload: spaceClipResult }) => {
            return ({

                ...state,
                error: null,
                spaceClipResult: spaceClipResult,
            })
        },
        [REQ_TYPE_USER_SPACE_DEL_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error: error,
                spaceClipResult: null,
            })
        },
        [REQ_TYPE_USER_SPACE_DEL_ALL_SUCCESS]: (state, { payload: spaceClipResult }) => {
            return ({

                ...state,
                error: null,
                spaceClipResult: spaceClipResult,
            })
        },
        [REQ_TYPE_USER_SPACE_DEL_ALL_FAILURE]: (state, { payload: error }) => {
            return ({
                ...state,
                error: error,
                spaceClipResult: null,
            })
        },
    },
    initialState,
);

export default userSpaceReducer;